export const environment = {
  production: "true",
  backendUrl: "https://api-mng.interplayers.com.br/pbm-portaladm-bff",
  mdmBackendUrl: "https://api-mng.interplayers.com.br/gip-mdm",
  pbmBenefitBackendUrl: "https://api-mng.interplayers.com.br/pbm-benefit-api/api/pbm/",
  mdmProductsBackendUrl: "https://api-mng.interplayers.com.br/mdm-product-api/api/mdm",
  authBaseUrl: "https://api-mng-gip.azure-api.net/gip-scsauth",
  reportUrl: "https://api-mng-gip.azure-api.net/gip-rpt",
  reportServiceUrl: "https://api-mng-gip.azure-api.net/gip-rpt-svc",
  authUserTokenValidationUrl: "https://api-mng-gip.azure-api.net/gip-scs",
  authServiceTokenValidationUrl: "https://api-mng-gip.azure-api.net/gip-scsauth",
  pipUrl: "https://portal.interplayers.com.br/pip/app",
  limiteBeneficiaryTemplateLink: "https://gippbmhealthy.blob.core.windows.net/templates/Limite_Beneficiario.csv",
  beneficiaryTemplateRegisterFileUploadLink: "https://gippbmhealthy.blob.core.windows.net/templates/Beneficiario_CadastroEmLote.csv",
  industryDiscountsTemplateRegisterFileUploadLink: "https://gippbmhealthy.blob.core.windows.net/templates/LPM_ArquivoEmLote.csv",
  pdvTokenUrl: "https://api-mng-gip.azure-api.net/gip-scs-svc/token",
  pdvUrl: "https://gip-pbm-portal-drogaria-app.interplayers.com.br/home",
  idpCommonApi: "https://idp-api-gtw.azure-api.net/idp-common-api-dev/",
  pbmBenefitApiKey: "8c9fab5970a042bcbeebb837d9967deb",
  productCatalog: "https://gip-mdm-catalog-app.interplayers.com.br/",
  clarityId: "l6ggdeyjz3",
  idpNetworkUrl: "https://api-mng.interplayers.com.br/idp-network-odata-api/",
  healthyCampaignsApiUrl: "https://api-mng.interplayers.com.br/healthy-campaigns-api",

  _________________READ_ME: "Propriedades que nao estao em formato de token devem ser iguais para todos ambientes. Se mudar, deve ser um token.",
  appName: "PBM-VPI",
  version: "2.18.1",
  authClientId: "1045",
  forgotPasswordUrl: "https://idpusrauth-api.azurewebsites.net",
  forgotPasswordConfirmationUrl: "https://adm.healthy-ip.com.br/reset-password",
  redirectOnExitingApp: "login",
  intervalRefresh: 10,
  totalPerPage: 10,
  clusterTemplateRegisterFileUploadLink: "https://pbmhealthy.blob.core.windows.net/templates/Cluster_ArquivoEmLote.csv",
  pdvTokenBodyRequest: "client_id=608dc177-7110-34d5-f573-ee2476a467aa&client_secret=yEkH954pxHnUme0lj9PtAzZbsZZjJlG7&grant_type=client_credentials",
  pdvClientId: "608dc177-7110-34d5-f573-ee2476a467aa",
  grantType: "ClientCredentials",
};
